import { ERROR_CODE } from '../types/error-codes';
import { SSORestrictType, type PostTenantSelectInfosItem } from '../types/tenant';
import _ from 'lodash';

export function getTenantErrorCodes(item: PostTenantSelectInfosItem) {
    const msgCode:Array<number> = [];
    if (_.isBoolean(item.account_status_active) && !item.account_status_active) {
        msgCode.push(ERROR_CODE.ACCOUNT_STATUS_ACTIVE)
    }

    if (item.domain_restrict) {
        msgCode.push(ERROR_CODE.DOMAIN_RESTRICT)
    }
    if (item.ip_restrict) {
        msgCode.push(ERROR_CODE.IP_RESTRICT)
    }
    if (item.sso_restrict) {
        if (item.sso_restrict_type === SSORestrictType.DINGTLK) {
            msgCode.push(ERROR_CODE.DING_TLK)
        } else if (item.sso_restrict_type === SSORestrictType.FEISHU) {
            msgCode.push(ERROR_CODE.FEISHU)
        } else if (item.sso_restrict_type === SSORestrictType.WECHAT_ENTERPRISE) {
            msgCode.push(ERROR_CODE.WECHAT_ENTERPRISE)
        } else if (item.sso_restrict_type === SSORestrictType.JWT) {
            msgCode.push(ERROR_CODE.JWT)
        } else {
            msgCode.push(ERROR_CODE.OTHERS)
        }
    }

    return msgCode
}
